/** Layout guard — redirects to /login when auth is on and no user is present. */
import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "@/auth/AuthContext";

export function RequireAuth() {
  const { authEnabled, user, loading } = useAuth();
  if (loading) return null; // AppRoutes renders the full-page loader
  if (authEnabled && !user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
